import { updateAppState } from '../../app/store/appReducer';


export const appInitThunk = (param = null) => {

    return (dispatch, getState) => {
		
		//console.log('location', getState().app);

        console.log(window.screen.width);
        console.log(window.screen.height);
        let userAgent = (window.navigator && window.navigator.userAgent) || 'default';
        //if (searchParams && searchParams.vk_platform && searchParams.vk_platform !== "desktop_web") {
        if ( (window.screen.width/window.screen.height) < 0.9 || window.screen.width < 777 || userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('Android') > -1 || userAgent.indexOf('mobile') > -1) {
            dispatch(updateAppState({
                isMobileView: true,
            }));
        }

    }
}
